import React, { useState, useEffect } from 'react'
import { Box, Typography, TextField } from '@mui/material'

function TaskDescription({ initialDescription, onDescriptionChange }) {
  const [description, setDescription] = useState(initialDescription || '')

  useEffect(() => {
    setDescription(initialDescription || '')
  }, [initialDescription])

  const handleDescriptionChange = (event) => {
    const value = event.target.value
    setDescription(value)
    onDescriptionChange(value)
  }

  return (
    <Box className="task-form-section">
      <div className="title-promos-form">
        <b class="bold-step">PASO 2: Escriba una descripción de la tarea que será visible para sus colaboradores en la aplicación</b>
      </div>
      <hr className="hr-task-form" />

      <Box />
      <Box className="task-form-control-width">
        <TextField
          fullWidth
          size="small"
          label="Descripción"
          value={description}
          onChange={handleDescriptionChange}
          placeholder="Ejemplo Tarea marca Ubiqua"
          inputProps={{ maxLength: 40 }}
          required
        />
        <Typography
          variant="caption"
          className="pdv-char-counter"
        >
          Cantidad máxima de caracteres {description.length}/40
        </Typography>
      </Box>

    </Box>
  )
}

export default TaskDescription
